import { REQUIRED } from '../../constants/validations';

const validate = values => {
  let errors = {};

  if (!values.credit_cstm) {
    errors.credit_cstm = REQUIRED;
  }

  if (!values.foreclosure) {
    errors.foreclosure = REQUIRED;
  }

  if (!values.bankruptcy) {
    errors.bankruptcy = REQUIRED;
  }

  if (!values.experience) {
    errors.experience = REQUIRED;
  }

  if (!values.non_entity_borrower) {
    errors.non_entity_borrower = REQUIRED;
  }

  if (!values.us_citizen) {
    errors.us_citizen = REQUIRED;
  }

  if (!values.checking_1_b) {
    errors.checking_1_b = REQUIRED;
  }

  if (!values.checking_2_b) {
    errors.checking_2_b = REQUIRED;
  }

  if (!values.savings_1_b) {
    errors.savings_1_b = REQUIRED;
  }

  if (!values.savings_2_b) {
    errors.savings_2_b = REQUIRED;
  }

  if (!values.stocks_bonds_1_b) {
    errors.stocks_bonds_1_b = REQUIRED;
  }

  if (!values.stocks_bonds_2_b) {
    errors.stocks_bonds_2_b = REQUIRED;
  }

  if (!values.retirement_1_b) {
    errors.retirement_1_b = REQUIRED;
  }

  if (!values.retirement_2_b) {
    errors.retirement_2_b = REQUIRED;
  }

  if (!values.other_real_estate_b) {
    errors.other_real_estate_b = REQUIRED;
  }

  if (!values.owed_primary_residence_b) {
    errors.owed_primary_residence_b = REQUIRED;
  }

  if (!values.owed_other_real_estate_b) {
    errors.owed_other_real_estate_b = REQUIRED;
  }

  if (!values.experience_lifetime) {
    errors.experience_lifetime = REQUIRED;
  }

  return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./src/Screens/BorrowerCredit/validate.js